<h1 translate
    matDialogTitle>
    processes_deploy_modal_title
</h1>

<form [formGroup]="form"
      (submit)="onSubmit()">
    <mat-dialog-content *ngLet="isCurrentFolderClassic$ | async as isCurrentFolderClassic"
                        class="process-modal-content">
        <mat-form-field>
            <ui-suggest [placeholder]="'processes_deploy_modal_package_name' | translate"
                        [defaultValue]="'processes_deploy_modal_package_name_empty' | translate"
                        [searchSourceFactory]="processSearchFactory"
                        [clearable]="false"
                        [displayCount]="5"
                        [required]="true"
                        (selected)="context.data.processKey = $event?.id;
                                    fetchPackages();"
                        (deselected)="packagesSuggest.removeSelection();"
                        formControlName="processKey"
                        data-cy="process-package-name">
            </ui-suggest>
        </mat-form-field>
        <mat-form-field>
            <ui-suggest #packagesSuggest
                        [placeholder]="'processes_deploy_modal_package_version' | translate"
                        [defaultValue]="'processes_deploy_modal_package_version_empty' | translate"
                        [items]="packages$ | async"
                        [disabled]="!context.data.processKey"
                        [searchable]="true"
                        [clearable]="false"
                        [displayCount]="5"
                        [loading]="!(packages$ | async)"
                        [required]="true"
                        (selected)="onVersionSelect($event)"
                        formControlName="processVersion"
                        data-cy="process-package-version">
            </ui-suggest>
        </mat-form-field>
        <mat-form-field *ngIf="isCurrentFolderClassic">
            <ui-suggest #environments
                        [placeholder]="'processes_deploy_modal_environment' | translate"
                        [defaultValue]="'processes_deploy_modal_environment_empty' | translate"
                        [clearable]="false"
                        [required]="true"
                        [displayCount]="5"
                        [searchSourceFactory]="environmentSearchFactory"
                        (selected)="context.data.environmentId = $event?.id;
                                    context.data.environmentName = $event?.text;"
                        (sourceInitialized)="$event.length === 1 &&
                                            environments.value = [$event[0]]"
                        direction="up"
                        formControlName="environment"
                        data-cy="process-environment-name">
            </ui-suggest>
        </mat-form-field>
        <mat-form-field>
            <input [placeholder]="'processes_deploy_modal_description' | translate"
                   matInput
                   formControlName="description"
                   name="description"
                   class="form-control"
                   data-cy="process-description" />
            <mat-hint *ngIf="!form.get('description')!.pristine &&
                            form.get('description')!.hasError('maxlength')"
                      [translateParams]="{
                                length: form.get('description')!.getError('maxlength')?.requiredLength
                            }"
                      translate
                      class="errorMessage">
                processes_deploy_modal_description_max_warning
            </mat-hint>
        </mat-form-field>

        <ui-card-info *ngIf="!isCurrentFolderClassic"
                      [message]="'processes_deploy_modal_modern_warning' | translate"
                      type="warn">
        </ui-card-info>

        <ui-process-io-parameters #parameterGrid
                                  [args]="args"
                                  [editable]="true"
                                  formControlName="arguments">
        </ui-process-io-parameters>

        <ui-process-settings #processSetting
                             *ngIf="isProcessSettingEnabled">
        </ui-process-settings>
    </mat-dialog-content>

    <mat-dialog-actions *ngLet="{
                            loading: loading$ | async
                        } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                type="button">
            {{'modal_action_cancel' | translate}}
        </button>
        <button [spinnerButtonLoading]="state.loading"
                [disabled]="state.loading ||
                            form.invalid ||
                            processSetting?.form.invalid ||
                            !!parameterGrid?.isOpen"
                ui-spinner-button
                mat-flat-button
                type="submit"
                color="primary"
                data-cy="process-submit">
            {{'modal_action_create' | translate}}
        </button>
    </mat-dialog-actions>
</form>
